import type { TrainingSheet } from '~/helpers/sessions/training-sheet'
import { useTranslation } from 'react-i18next'
import { isSheetEmpty, SHEET_TEXT_FIELDS } from '~/helpers/sessions/training-sheet'
import { tourAnchor } from '~/helpers/tour/anchors'

/**
 * « À propos de cette formation » (#319) : la fiche que l'organisme a remplie,
 * repliée pour ne pas pousser les étapes hors de l'écran. Absente quand la
 * fiche est vide.
 */
function TrainingSheetCard({ sheet }: { sheet: TrainingSheet }) {
  const { t } = useTranslation()
  if (isSheetEmpty(sheet)) return null

  return (
    <details className="mb-6 rounded-2xl border border-border bg-card p-5" {...tourAnchor('path.sheet')}>
      <summary className="cursor-pointer font-heading text-lg">{t('path.sheet.title')}</summary>
      <dl className="mt-4 flex flex-col gap-4 text-sm">
        {!!sheet.objectives?.length && (
          <div>
            <dt className="font-medium">{t('sheet.objectives')}</dt>
            <dd>
              <ul className="mt-1 list-disc pl-5 text-muted-foreground">
                {sheet.objectives.map(objective => <li key={objective}>{objective}</li>)}
              </ul>
            </dd>
          </div>
        )}
        {SHEET_TEXT_FIELDS.filter(field => sheet[field]).map(field => (
          <div key={field}>
            <dt className="font-medium">{t(`sheet.${field}`)}</dt>
            <dd className="mt-1 whitespace-pre-line text-muted-foreground">{sheet[field]}</dd>
          </div>
        ))}
        {sheet.contact && (
          <div>
            <dt className="font-medium">{t('sheet.contact')}</dt>
            <dd className="mt-1 text-muted-foreground">{sheet.contact}</dd>
          </div>
        )}
      </dl>
    </details>
  )
}

export default TrainingSheetCard
